import React, { FC } from 'react';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { PrerollSkipButtonGroup } from './component';

interface Props {
    className?: string;
    currentFragment: SkippableFragment | undefined;
}

export const PrerollSkipButtonGroupContainer: FC<Props> = ({ currentFragment, ...rest }) => {
    if (currentFragment?.type !== 'PREROLL') {
        return null;
    }

    return <PrerollSkipButtonGroup currentFragment={currentFragment} {...rest} />;
};
